import styled from 'styled-components';
import { fonts, pxToCssFont } from '@vfit/shared/themes';

export const PopupTitle = styled.div<{ haveBorder?: boolean }>`
  p {
    margin: 0;
  }
  font-family: ${fonts.exbold};
  ${pxToCssFont(30, 38)}
  margin-bottom: 32px;
`;
